import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Popup', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticClass: "address-poper",
    attrs: {
      "show-mask": true
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('popup-header', {
    attrs: {
      "left-text": i18n.tc("11"),
      "right-text": i18n.tc("12"),
      "title": i18n.tc("498"),
      "show-bottom-border": false
    },
    on: {
      "on-click-left": function ($event) {
        _vm.currValue = false;
      },
      "on-click-right": _vm.rigthClick
    }
  }), _c('div', {
    staticClass: "select"
  }, [_c('Tab', {
    staticClass: "tab",
    attrs: {
      "default-color": "#1a1e24",
      "active-color": "#3ccba6",
      "bar-active-color": "#3ccba6",
      "custom-bar-width": "15px",
      "line-width": 2,
      "value": _vm.active
    }
  }, _vm._l(_vm.adsLevel, function (item) {
    return _c('TabItem', {
      key: item,
      attrs: {
        "disabled": ""
      }
    }, [_vm._v(_vm._s(item))]);
  }), 1), _c('div', {
    staticClass: "address_list"
  }, _vm._l(_vm.realList, function (item, index) {
    return _c('div', {
      key: index,
      ref: "area-list",
      refInFor: true,
      staticClass: "area-list"
    }, _vm._l(item.data, function (area, key) {
      return _c('div', {
        key: area.id,
        staticClass: "area-item",
        class: {
          'area-selected': _vm.selectedValue[index] && _vm.selectedValue[index].id === area.id
        },
        on: {
          "click": function ($event) {
            return _vm.click(area, index);
          }
        }
      }, [_c('p', [_vm._v(_vm._s(area.name))])]);
    }), 0);
  }), 0)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };